export default __webpack_public_path__ + "static/media/7.6511e2f0.png";